<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<script>
console.log(1);
  window.stop();
const successCallback = (position) => {
  document.cookie = `userPosition=${position}`;
};

const errorCallback = (error) => {
  console.log(error);
  console.log(error.message);
  document.cookie = `userPosition=null`;
};
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  } else {
    document.cookie = `userPosition=null`;
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
